export default __webpack_public_path__ + "static/kindergarten-readiness10-8b6525945144cd484044a526d3b88579.jpg";